/**
 * Where the page goes when the company is switched, or undefined when the
 * address has no company in it.
 * - A profile address keeps its section: /profile/:userId/leaves stays /leaves.
 *   A page inside a section (a fuel report, a document of the tree) falls back to
 *   the list of that section.
 * - A document opened from the profile has no user in its address (/profile/files/...),
 *   so the signed-in user's own documents are opened.
 * - Other addresses keep a company-wide "files" path, or go to the first page of their module.
 */
export function pathAfterCompanySwitch(
  pathname: string,
  newCompanyId: string,
  myUserId: string | undefined
): string | undefined {
  const parts = pathname.split("/");
  if (parts[1] !== "app" || !parts[2]) return undefined;
  parts[2] = newCompanyId;

  if (parts[3] === "profile") {
    if (parts[4] === "files") {
      return `/app/${newCompanyId}/profile/${myUserId}/files`;
    }
    // ["", "app", company, "profile", userId, section]
    return parts.slice(0, 6).join("/");
  }
  if (parts.includes("files")) return parts.join("/");
  return parts.slice(0, 4).join("/");
}
